import { createApiClient } from "./client";

const client = createApiClient();

export const exams = {
  saveDemographics: ({ data, userId }) =>
    client
      .post(
        `/participants/${userId}/demographics`, data
      )
      .then(({ data }) => data),

  getAssesmentsv2: ({ type, id, currentPage, perPage, search }) =>
    client
      .get(
        `/candidates/${id}/exams?per_page=${perPage}&page=${currentPage}${type ? `&type=${type}` : ""
        }${search ? `&search=${search}` : ""}`
      )
      .then(({ data }) => data),

  // client_id is only set for culture audit (one access_code's login response
  // carries the client it belongs to — see the backend's
  // culture-audit-backend-build-steps doc). It scopes survey_template_id
  // lookups to that client, since the same template id can otherwise resolve
  // to another client's copy. 360/appraisal never pass it.
  getSurveys: ({ type, id, currentPage, perPage, search, client_id }) =>
    client
      .get(
        `/participants/${id}/surveys?per_page=${perPage}&page=${currentPage}${type ? `&type=${type}` : ""
        }${search ? `&search=${search}` : ""}${client_id ? `&client_id=${client_id}` : ""}`
      )
      .then(({ data }) => data),

  getReviews: ({ type, id, currentPage, perPage, search }) =>
    client
      .get(
        `/reviewers/${id}/surveys?per_page=${perPage}&page=${currentPage}${type ? `&type=${type}` : ""
        }${search ? `&search=${search}` : ""}`
      )
      .then(({ data }) => data),

  getParticipantResponse: ({ userId, userExamId }) =>
    client
      .get(`/participants/${userId}/surveys/${userExamId}/preview-responses`)
      .then(({ data }) => data),

  // getExamQuestionsv2: ({ userId, examId, userExamId,language ,showOnlyQuestions, switchQuestion, level, number_of_attempts }) =>
  //   client
  //     .get(`/candidates/${userId}/exams/${examId}/questions/${userExamId}?showOnlyQuestions=${showOnlyQuestions}&language=${language}${
  //       switchQuestion ? `&switchQuestions=${switchQuestion}` : ""
  //     }${level ? `&level=${level}` : ""}${number_of_attempts ? `&attempt=${number_of_attempts}` : ""}`)
  //     .then(({ data }) => data),

  // assessmentId is only set for culture audit (one UserExam spans several
  // assessments there — see the backend's culture-audit-backend-build-steps
  // doc, Phase 3). 360/appraisal never pass it, so their requests keep
  // hitting the original `/surveys/:examId` route unchanged.
  getExamQuestionsv2: ({ userId, examId, userExamId, assessmentId, language, showOnlyQuestions, switchQuestion, level, number_of_attempts }) =>
    client
      .get(`/participants/${userId}/surveys/${examId}${assessmentId ? `/assessments/${assessmentId}` : ""}?showOnlyQuestions=${showOnlyQuestions}&language=${language}${switchQuestion ? `&switchQuestions=${switchQuestion}` : ""
        }${level ? `&level=${level}` : ""}${number_of_attempts ? `&attempt=${number_of_attempts}` : ""}`)
      .then(({ data }) => data),

  getReviewerExamQuestionsv2: ({ userId, userExamId, reviewerId, language }) =>
    client
      .get(`reviewers/${reviewerId}/participants/${userId}/surveys/${userExamId}${language ? `?language=${language}` : ""}`)
      .then(({ data }) => data),

  getSurveyResponse: ({ userId, userExamId }) =>
    client
      .get(`/view-responses/${userId}/${userExamId}`)
      .then(({ data }) => data),

  /* UPDATE ANSWERS */
  // assessmentId: see getExamQuestionsv2 note above — culture audit only.
  updateAnswersv2: ({ data, userId, examId, userExamId, assessmentId }) =>
    client
      .post(
        `/participants/${userId}/surveys/${userExamId}${assessmentId ? `/assessments/${assessmentId}` : ""}/save-answers`,
        //`/candidates/${userId}/exams/${examId}/questions/${userExamId}/save-answers`,
        data
      )
      .then(({ data }) => data),

  updateAnswersv2Review: ({ data, userId, examId, userExamId, reviewerId }) =>
    client
      .post(
        `/reviewers/${reviewerId}/participants/${userId}/surveys/${userExamId}/save-answers`,
        data
      )
      .then(({ data }) => data),

  // gradeAssessmentv2: ({ userId, examId, userExamId, attempt  }) =>
  //   client
  //     .post(
  //       `/candidates/${userId}/exams/${examId}/questions/${userExamId}/submit-exam`, {attempt}
  //     )
  //     .then(({ data }) => data),

  // assessmentId: see getExamQuestionsv2 note above — culture audit only.
  gradeAssessmentv2: ({ userId, examId, userExamId, assessmentId, attempt }) =>
    client
      .post(
        `/participants/${userId}/surveys/${examId}${assessmentId ? `/assessments/${assessmentId}` : ""}/submit-assessment`, { attempt }
      )
      .then(({ data }) => data),

  gradeSurveyReviewv2: ({ userId, examId, userExamId, attempt, reviewerId }) =>
    client
      .post(
        `/reviewers/${reviewerId}/participants/${userId}/surveys/${examId}/submit-assessment`,
      )
      .then(({ data }) => data),
  getExamsHistoryv2: ({ id, currentPage, perPage, search }) =>
    client
      .get(
        `/candidates/${id}/exams/history?per_page=${perPage}&page=${currentPage}${search ? `&search=${search}` : ""
        }`
      )
      .then(({ data }) => data),

  getBookingsv2: (userId, examId) =>
    client
      .get(`/candidates/${userId}/exams/${examId}/bookings`)
      .then(({ data }) => data),

  getBranding: () =>
    client
      .get(`/clients/6b9d247d-78ba-417f-9fcf-ae8fc3e574d9`)
      .then(({ data }) => data),

  createBookingv2: ({ userId, examId, payload }) =>
    client
      .post(`/candidates/${userId}/exams/${examId}/bookings`, { ...payload })
      .then(({ data }) => data),

  unlockAssessmentv2: (userId, examId, payload) =>
    client
      .post(`/candidates/${userId}/exams/${examId}/bookings/activate`, {
        ...payload,
      })
      .then(({ data }) => data),

  loginBasedLinkExam: (payload) =>
    client.post(`/auth/login/exam`, { ...payload }).then(({ data }) => data),
  getExamResults: ({ userId, examId, userExamId }) =>
    client
      .get(`/candidates/${userId}/exams/${examId}/results/${userExamId}`)
      .then(({ data }) => data),
  retakeExam: ({ userId, examId }) =>
    client
      .post(`/candidates/${userId}/exams/${examId}/retry`)
      .then(({ data }) => data),
};
